import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { PUBLIC } from "constants/index"
import { wishItemActions } from "constants/options"
import { updateSearchedUserIsLoggedInUser } from "appRedux/slices/globalSlice"
import { updateWishListInfo } from "appRedux/slices/wishListSlice"
import WishItemPageTemplate from "components/templates/WishItemPageTemplate"
import useWishItems from "hooks/useWishItems"
import useResolveCurrentItemIndex from "hooks/useResolveCurrentItemIndex"

export default function WishItemsPage() {
  const dispatch = useDispatch()

  const { items } = useWishItems()

  useResolveCurrentItemIndex(items)

  useEffect(() => {
    dispatch(updateSearchedUserIsLoggedInUser(false))
  }, [])

  useEffect(() => {
    dispatch(updateWishListInfo(getMockWishListForAllItems(items)))
  }, [JSON.stringify(items)])

  function getMockWishListForAllItems(wishItems: WishItem[]) {
    return {
      id: -1,
      name: "",
      privacy: PUBLIC,
      listItems: wishItems,
      itemCount: wishItems.length,
      createdAt: new Date(),
      updatedAt: new Date()
    } as WishList
  }

  return (
    <WishItemPageTemplate
      wishItems={items || []}
      moreButtonActions={wishItemActions}
    />
  )
}
